// Client mirror of the backend framework (labels, colors, level helpers).

export const DOMAINS = [
  { id: "execution", name: "Execution & Professional Reliability", short: "Execution", color: "#005291" },
  { id: "cognitive", name: "Cognitive & Analytical Capacity", short: "Cognitive", color: "#10b981" },
  { id: "growth", name: "Growth & Leadership Capacity", short: "Growth", color: "#78be21" },
];

export const SKILLS = [
  { id: "intercultural_comm", name: "Communication", short: "Communication", domain: "execution" },
  { id: "prof_ethics", name: "Ethical Responsibility", short: "Ethics", domain: "execution" },
  { id: "proj_task_mgmt", name: "Self-Management", short: "Self-Mgmt", domain: "execution" },
  { id: "critical_solving", name: "Critical Thinking", short: "Critical Thinking", domain: "cognitive" },
  { id: "data_literacy", name: "Problem Solving", short: "Problem Solving", domain: "cognitive" },
  { id: "systems_thinking", name: "Metacognition", short: "Metacognition", domain: "cognitive" },
  { id: "digital_adapt", name: "Leadership", short: "Leadership", domain: "growth" },
  { id: "collab_leadership", name: "Collaboration", short: "Collaboration", domain: "growth" },
  { id: "creative_synthesis", name: "Growth Mindset", short: "Growth Mindset", domain: "growth" },
  { id: "self_resilience", name: "Resilience", short: "Resilience", domain: "growth" },
];

export const LEVELS = [
  { id: "emerging", name: "Emerging", min: 1.0, max: 1.99, hex: "#d97706",
    badge: "bg-amber-100 text-amber-900 border-amber-300" },
  { id: "developing", name: "Developing", min: 2.0, max: 2.99, hex: "#2563eb",
    badge: "bg-blue-100 text-blue-900 border-blue-300" },
  { id: "proficient", name: "Proficient", min: 3.0, max: 3.49, hex: "#0d9488",
    badge: "bg-teal-100 text-teal-900 border-teal-300" },
  { id: "advanced", name: "Advanced", min: 3.5, max: 4.0, hex: "#10b981",
    badge: "bg-emerald-100 text-emerald-800 border-emerald-400" },
];

export const levelFor = (score) =>
  LEVELS.find((lv) => score <= lv.max + 1e-9) || LEVELS[LEVELS.length - 1];

export const domainColor = (id) => DOMAINS.find((d) => d.id === id)?.color || "#005291";
export const skillMeta = (id) => SKILLS.find((s) => s.id === id);
export const to100 = (tsb) => Math.round(Math.max(0, Math.min(100, ((tsb - 1) / 3) * 100)) * 10) / 10;
